module.exports = __webpack_public_path__ + "img/958.6c3330f6.jpg";